<form [formGroup]="formGroup" (submit)="submit()" class="form">
  <div class="fields">
    <fip-form>
      <mat-form-field class="field">
        <mat-label>Monitor Name</mat-label>
        <input matInput type="text" formControlName="name" data-cy="name" />
      </mat-form-field>
    </fip-form>
    <div class="field-group">
      <fip-form>
        <mat-form-field class="field">
          <mat-label>Initial Query Date</mat-label>
          <input
            matInput
            [min]="today"
            [matDatepicker]="initialQueryDate"
            formControlName="initialQueryDate"
          />
          <mat-datepicker-toggle
            matIconSuffix
            [for]="initialQueryDate"
          ></mat-datepicker-toggle>
          <mat-datepicker #initialQueryDate></mat-datepicker>
        </mat-form-field>
      </fip-form>
      <fip-form>
        <mat-form-field class="field">
          <mat-label>Recipients Group</mat-label>
          <mat-select
            formControlName="recipientsGroupId"
            data-cy="recipient-group-select"
            [fipEnableOnLoad]="recipientsGroups$"
          >
            @for (group of recipientsGroups$ | async; track group) {
              <mat-option [value]="group.rowKey">{{ group.name }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </fip-form>
    </div>
  </div>
  <div class="actions">
    <button
      mat-flat-button
      color="primary"
      data-cy="submit-button"
      [disabled]="formGroup.invalid"
    >
      {{ submitTitle() }}
    </button>
  </div>
</form>
